import React from 'react';
import { Button, Input } from 'antd';
import IntlMessages from '@src/util/IntlMessages';
import Title from './Title';
import { default as TitleLabel } from '@components/BoxContainer/components/Title';

export default function ResetPasswordForm({ onSubmit }) {
  const [password, setPassword] = React.useState({
    password: '',
    confirmPassword: '',
  });
  const [disabledButton, setDisabledButton] = React.useState(true);

  const onChangePassword = e => {
    const { name, value } = e.target;
    const updatedPassword = { ...password, [name]: value };

    setPassword(updatedPassword);

    const isValid =
      updatedPassword.password === updatedPassword.confirmPassword &&
      updatedPassword.password.length > 5 &&
      updatedPassword.confirmPassword.length > 5;

    setDisabledButton(!isValid);
  };

  return (
    <>
      <Title>
        <IntlMessages id="app.userAuth.resetPassword" />
      </Title>
      <div className="gx-mt-2 gx-mb-2">
        <IntlMessages id="app.userAuth.resetPasswordDescription" />
      </div>
      <div className="gx-flex-column gx-guarnic-gap-2">
        <div className="gx-flex-column gx-guarnic-gap-1">
          <div>
            <label htmlFor="password" className="gx-d-block gx-mb-1">
              <TitleLabel.LabelForm value={<IntlMessages id="app.userAuth.enter.password" />} />
            </label>
            <Input.Password name="password" onChange={onChangePassword} />
          </div>
          <div>
            <label htmlFor="confirmPassword" className="gx-d-block gx-mb-1">
              <TitleLabel.LabelForm
                value={<IntlMessages id="app.userAuth.enter.password.again" />}
              />
            </label>
            <Input.Password name="confirmPassword" onChange={onChangePassword} />
          </div>
        </div>

        <Button
          onClick={() => onSubmit(password.password)}
          disabled={disabledButton}
          type="primary"
          block
        >
          <IntlMessages id="app.userAuth.resetPassword" />
        </Button>
      </div>
    </>
  );
}
